import Vue from 'vue'
import Router from 'vue-router'
import { Store } from '../RF_store/index'
import Bugsnag from '../plugins/bugsnag'
// eslint-disable-next-line camelcase
import rf_welcome from '../views/rf_welcome.vue'
import mixpanel from '../plugins/mixPanel'

Vue.use(Router)

function lazyLoad(view) {
  return () => import(`../views/${view}.vue`)
}

const routes = [
  // Happy Flow
  {
    path: '/',
    name: 'welcome',
    component: rf_welcome,
    beforeEnter: (to, from, next) => {
      Store.commit('customer/setMultiKeyValues', {
        customerId: '',
        leadExternalId: '',
        email: '',
      })
      next()
    },
  },
  {
    path: '/ob/intro',
    name: 'intro',
    component: lazyLoad('rf_intro'),
    beforeEnter: (to, from, next) => {
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '1' })
      handleNext(from, next)
    },
  },
  {
    path: '/ob/phone',
    name: 'phone',
    component: lazyLoad('rf_contact'),
    beforeEnter: (to, from, next) => {
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '2' })
      handleNext(from, next)
    },
  },
  {
    path: '/ob/enterKYC',
    name: 'ssn',
    component: lazyLoad('rf_identity'),
    beforeEnter: (to, from, next) => {
      Store.dispatch('errors/clearAllFormErrors')
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '3' })
      handleNext(from, next)
    },
  },
  {
    path: '/ob/enterAddressDetail',
    component: lazyLoad('rf_address'),
    name: 'address',
    beforeEnter: (to, from, next) => {
      Store.dispatch('errors/clearAllFormErrors')
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '4' })
      handleNext(from, next)
    },
  },
  {
    path: '/ob/business-type-selection',
    name: 'businessTypeSelection',
    component: lazyLoad('rf_businessTypeSelection'),
    beforeEnter: (to, from, next) => {
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '5' })
      handleNext(from, next)
    },
  },
  {
    path: '/ob/business-info-description',
    name: 'businessInformationDescription',
    component: lazyLoad('rf_business_info_3'),
    beforeEnter: (to, from, next) => {
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '5' })
      handleNext(from, next)
    },
  },

  {
    path: '/ob/business-info-business-with',
    name: 'businessInformationBusinessWith',
    component: lazyLoad('rf_business_info_4_business_with'),
    beforeEnter: (to, from, next) => {
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '5' })
      handleNext(from, next)
    },
  },

  {
    path: '/ob/business-info-expected-payments',
    name: 'businessInformationExpectedPayments',
    component: lazyLoad('rf_business_info_5_expected_payment'),
    beforeEnter: (to, from, next) => {
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '5' })
      handleNext(from, next)
    },
  },

  {
    path: '/ob/business-sub-type',
    name: 'businessTypeSelectionSubType',
    component: lazyLoad('rf_businessSubTypeSelection'),
    beforeEnter: (to, from, next) => {
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '5' })
      handleNext(from, next)
    },
  },
  {
    path: '/ob/business-dba-type',
    name: 'businessDbaType',
    component: lazyLoad('rf_businessDBASelection'),
    beforeEnter: (to, from, next) => {
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '5' })
      handleNext(from, next)
    },
  },
  {
    path: '/ob/industry',
    name: 'industry',
    component: lazyLoad('rf_industry'),
    beforeEnter: (to, from, next) => {
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '5' })
      handleNext(from, next)
    },
  },
  {
    path: '/ob/business',
    name: 'business',
    component: lazyLoad('rf_business_v2'),
    beforeEnter: (to, from, next) => {
      Store.dispatch('errors/clearAllFormErrors')
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '5' })
      handleNext(from, next)
    },
  },
  {
    path: '/ob/mailing-address',
    name: 'mailingAddress',
    component: lazyLoad('mailingAddress'),
    beforeEnter: (to, from, next) => {
      Store.dispatch('errors/clearAllFormErrors')
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '6' })
      handleNext(from, next)
    },
  },
  {
    path: '/ob/business-address',
    name: 'businessAddress',
    component: lazyLoad('rf_businessAddress'),
    beforeEnter: (to, from, next) => {
      Store.dispatch('errors/clearAllFormErrors')
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '6' })
      handleNext(from, next)
    },
  },
  {
    path: '/ob/owners-center',
    name: 'ownersCenter',
    component: lazyLoad('rf_ownersCenter'),
    beforeEnter: (to, from, next) => {
      Store.dispatch('errors/clearAllFormErrors')
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '6' })
      handleNext(from, next)
    },
  },
  {
    path: '/ob/add-owner',
    name: 'addOwner',
    component: lazyLoad('rf_addOwner'),
    beforeEnter: (to, from, next) => {
      Store.dispatch('errors/clearAllFormErrors')
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '6' })
      handleNext(from, next)
    },
  },
  {
    path: '/ob/account-type',
    name: 'plan',
    component: lazyLoad('rf_plan'),
    beforeEnter: (to, from, next) => {
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '7' })
      handleNext(from, next)
    },
  },
  {
    path: '/ob/AccountCreationReason',
    name: 'whyopenaccount',
    component: lazyLoad('rf_howDidYouHearAboutLili'),
    beforeEnter: (to, from, next) => {
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '8' })
      handleNext(from, next)
    },
  },
  {
    path: '/ob/confirmDetails',
    component: lazyLoad('rf_review'),
    name: 'review',
    beforeEnter: (to, from, next) => {
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '9' })
      handleNext(from, next)
    },
  },
  {
    path: '/ob/approved-login',
    name: 'approved-login',
    component: () => import('../views/auth/ApprovedLogin/index.vue'),
  },

  {
    path: '/ob/approved',
    component: lazyLoad('rf_approved'),
    name: 'approved',
    beforeEnter: (to, from, next) => {
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '10' })
      handleNext(from, next)
    },
  },

  {
    path: '/ob/verification',
    component: lazyLoad('rf_verification'),
    name: 'verification',
    beforeEnter: (to, from, next) => {
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '11' })
      handleNext(from, next)
    },
  },

  // Done Happy Flow -------------------------
  // Additional Business Flow
  {
    path: '/multi/intro',
    name: 'multiIntro',
    component: () => import('../views/multiAccount/MultiIntro.vue'),
  },
  {
    path: '/multi/success',
    name: 'MultiSuccess',
    component: () => import('../views/multiAccount/MultiAccountSuccess.vue'),
  },
  // UBO Enrollment flow
  {
    path: '/ubo/intro',
    name: 'uboIntro',
    component: () => import('../views/uboEnroll/UboIntro.vue'),
    beforeEnter: (to, from, next) => {
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '10' })
      next()
    },
  },
  {
    path: '/ubo/mfa',
    name: 'uboMfa',
    component: () => import('../views/uboEnroll/UboMfa.vue'),
    beforeEnter: (to, from, next) => {
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '1' })
      next()
    },
  },
  {
    path: '/ubo/ssn',
    name: 'uboSsn',
    component: () => import('../views/uboEnroll/UboSsn.vue'),
    beforeEnter: (to, from, next) => {
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '3' })
      next()
    },
  },
  {
    path: '/ubo/password',
    name: 'uboPass',
    component: () => import('../views/uboEnroll/UboPassword.vue'),
    beforeEnter: (to, from, next) => {
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '6' })
      next()
    },
  },
  {
    path: '/ubo/complete',
    name: 'UboComplete',
    component: () => import('../views/uboEnroll/UboComplete.vue'),
    beforeEnter: (to, from, next) => {
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '10' })
      next()
    },
  },
  // -----------------
  // Failure Routes
  {
    path: '/ob/verificationCenter',
    name: 'verificationCenter',
    component: () =>
      import('../views/kybViews/VerificationCenterV2/VerificationCenterV2.vue'),
    beforeEnter: (to, from, next) => {
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '10' })
      next()
    },
  },
  {
    path: '/ob/kybPending',
    name: 'kybPending',
    component: () => import('../views/kybViews/kybPending.vue'),
    beforeEnter: (to, from, next) => {
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '10' })
      next()
    },
  },
  {
    path: '/ob/kybThankYou',
    name: 'kybThankYou',
    component: () => import('../views/kybViews/kybThankYou.vue'),
    beforeEnter: (to, from, next) => {
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '10' })
      next()
    },
  },
  {
    path: '/ob/OTP',
    name: 'otp',
    component: () => import('../views/auth/Otp.vue'),
    beforeEnter: (to, from, next) => {
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '10' })
      next()
    },
  },
  {
    path: '/ob/email-verification',
    name: 'email-verification',
    component: () => import('../views/auth/EmailVerification/index.vue'),
    beforeEnter: (to, from, next) => {
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '10' })
      next()
    },
  },
  {
    path: '/ob/securityQuestion',
    name: 'securityQuestion',
    component: () => import('../views/auth/SecurityQuestion.vue'),
    beforeEnter: (to, from, next) => {
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '10' })
      next()
    },
  },
  {
    path: '/ob/reset-password',
    name: 'resetPassword',
    component: () => import('../views/auth/ResetPassword.vue'),
    beforeEnter: (to, from, next) => {
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '10' })
      next()
    },
  },
  {
    path: '/ob/checkDocs',
    name: 'checkDocs',
    component: () => import('../views/kycFailedViews/CheckDocks.vue'),
    beforeEnter: (to, from, next) => {
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '10' })
      next()
    },
  },
  {
    path: '/ob/alreadyHaveAccount',
    name: 'accountExists',
    component: () => import(`../components/pages/account-exists.vue`),
  },
  {
    path: '/ob/continue-onboarding',
    name: 'login',
    component: () => import(`../views/auth/Login.vue`),
  },
  {
    path: '/ob/noBusinessDone',
    name: 'noBusinessDone',
    component: () => import('../views/kycFailedViews/NoBusinessDone.vue'),
  },
  {
    path: '/ob/noContinueDone',
    name: 'Login',
    component: () => import('../views/kycFailedViews/NoContinueDone.vue'),
    beforeEnter: (to, from, next) => {
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '10' })
      next()
    },
  },
  {
    path: '/ob/noContinueMoreInfo',
    component: () =>
      import(`../components/pages/stop-failed-kyc-more-info.vue`),
  },
  {
    path: '/ob/uploadDocs',
    component: () =>
      import(`../components/pages/stop-failed-kyc-more-info-upload.vue`),
  },
  {
    path: '/ob/uploadDocsComplete',
    component: () =>
      import(`../components/pages/stop-failed-kyc-more-upload-thanks.vue`),
  },
  {
    path: '/ob/noContinueChecking',
    name: 'noContinueChecking',
    component: () => import('../views/kycFailedViews/NoContinueChecking.vue'),
    beforeEnter: (to, from, next) => {
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '10' })
      next()
    },
  },
  {
    path: '/ob/debitCardName',
    name: 'DebitCardName',
    component: () => import('../views/kycFailedViews/DebitCardName.vue'),
    beforeEnter: (to, from, next) => {
      Store.commit('onboarding/setKeyValue', { prop: 'currStep', value: '10' })
      next()
    },
  },
  {
    path: '/ob/tnc',
    name: 'tnc',
    component: () => import(`../components/pages/tnc.vue`),
  },
  { path: '*', name: 'not found', component: rf_welcome },
]

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    } // Scroll to top of the page
  },
})

// Before enter to any route, do something
router.beforeEach((to, from, next) => {
  // Report page view
  mixpanel.track('Page Viewed', {
    page: to.path,
    origin: from.fullPath,
    pageName: to.name,
    query: from.fullPath,
  })
  // No reason to save server errors between routes
  Store.dispatch('errors/clearAllFormErrors')
  // Save last route origin
  Store.commit('customer/setKeyValue', {
    prop: 'fromRoute',
    value: from.fullPath,
  })
  // Avoid duplicate navigation
  if (to.name === from.name && to.query === from.query) {
    next(false)
  } else {
    next()
  }
})

const isFromFailedKycView = (viewName) => {
  const views = Store.getters['onboarding/data'].failedKycRoutes
  return views.includes(viewName)
}

const handleNext = (from, next) => {
  if (isFromFailedKycView(from.name)) {
    next({
      name: 'welcome',
      query: { should_persist: false },
    })
  } else {
    next()
  }
}

// On error failure notify to bugsnag
router.onError((err) => {
  Bugsnag.notify(JSON.stringify(err))
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js